// extracted by mini-css-extract-plugin
export default {"navbar":"DashboardNavbar_navbar__bYa8b","active":"DashboardNavbar_active__vNEx4","subnavigation":"DashboardNavbar_subnavigation__FXsYl"};